const environment={apiPrefix:"https://api-dev.backoffice.parnanoronha.nscreen.com.br/",enableMock:false};export default environment;